import React from 'react';
import Icon, { LoadingOutlined } from '@ant-design/icons';
import { Space, Spin } from 'antd';

const LoaderSpin = (props) => {
	return (
		<Space size={6} className="w-100 text-center" direction="vertical">
			<Spin  indicator={<LoadingOutlined spin />} size="small"/>
		</Space>
	);
};




const LoaderIcon = props => <Icon component={LoaderSpin} {...props} />

export default LoaderIcon;

